import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'

export function isSelfServiceRebookAllowed(offer?: App.Offer, order?: App.Order, cancellationConfig?: App.OrderItemHotelCancellationConfig): boolean {
  if (!offer) return false
  if (order?.orderGift) return false
  if (!cancellationConfig?.canAutoRefund) return false
  return !!offer.packageUpgradesAllowed && scheduleIsCurrent(offer.onlinePurchaseSchedule)
}
